import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asllab',
  templateUrl: './asllab.component.html',
  styleUrls: ['./asllab.component.scss']
})
export class AsllabComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
